import { createSelector } from 'reselect'
import modelsForCarlineRequestIsPendingSelector from '../pending-request/modelsForCarlineRequestIsPendingSelector'
import configurationRequestIsPendingSelector from '../pending-request/configurationRequestIsPendingSelector'

const modelSelectionIsLoadingSelector = createSelector(
    modelsForCarlineRequestIsPendingSelector,
    configurationRequestIsPendingSelector,
    (modelsRequestIsPending, configurationRequestIsPending): boolean => (
        modelsRequestIsPending || configurationRequestIsPending
    ),
)

export default modelSelectionIsLoadingSelector
